<div class="py-4 px-5 sm:px-10 pb-2 border-b bg-card dark:bg-accent-800">
  <div class="flex flex-col sm:flex-row items-center justify-between py-4">
    <div class="flex-1 min-w-0">
      <!-- Breadcrumbs -->
      <ng-content select="[breadCrumbs]"></ng-content>

      <!-- Title -->
      <h1
        class="text-3xl md:text-3xl font-extrabold tracking-tight leading-7 sm:leading-10 capitalize"
      >
        <ng-content select="[title]"></ng-content>
      </h1>
    </div>

    <!-- Actions -->
    <div class="flex flex-row justify-end pt-3 sm:pt-0 text-center">
      <ng-content select="[actions]"></ng-content>
    </div>

    <!-- Floating Action -->
    <div fab class="fab" *ngIf="isMobile">
      <ng-content select="[fab]"></ng-content>
    </div>
  </div>

  <div
    class="flex flex-row items-center justify-between mb-3 pb-1 sm:mb-0 overflow-x-auto overflow-y-hidden"
  >
    <!-- Submenu -->
    <div class="flex flex-row" *ngIf="!isMobile">
      <ng-container *ngTemplateOutlet="containerSubmenu"></ng-container>
    </div>

    <!-- Submenu-Mobile -->
    <div class="navbar shadow-navbar" *ngIf="isMobile && navbar">
      <div
        class="flex flex-col flex-auto bg-card dark:bg-accent-800 p-2 overflow-hidden even-border"
      >
        <div class="flex flex-row justify-evenly p-3">
          <ng-container *ngTemplateOutlet="containerSubmenu"></ng-container>
        </div>
      </div>
    </div>

    <!-- View actions -->
    <div class="flex-row justify-end">
      <div class="flex-row justify-end">
        <ng-content select="[viewActions]"></ng-content>
      </div>
    </div>
  </div>
</div>
<div
  *ngIf="showNotificationBanner && checkNotificationGranted()"
  class="flex flex-row items-center w-full p-2 text-primary text-lg bg-primary-400 bg-opacity-20"
>
  <mat-icon
    class="icon-size-4 me-2"
    [svgIcon]="'heroicons_outline:bell'"
    color="primary"
  ></mat-icon>
  <span class="flex-auto"
    >{{ 'For better experience allow the notifications from the browser' | transloco
    }}<button (click)="requestNotifications()" class="mx-1 underline font-bold">
      {{ 'Settings' | transloco }}
    </button></span
  >
  <button
    (click)="closeNotificationBanner()"
    class="me-4 mt-1 close-button"
    [matTooltip]="'Dismiss' | transloco"
  >
    <mat-icon color="primary" class="icon-size-4 me-2" [svgIcon]="'heroicons_solid:x'"></mat-icon>
  </button>
</div>

<!-- Loading bar -->
<div class="w-full" *ngIf="loading > 0 && loading < 100">
  <mat-progress-bar mode="determinate" [value]="loading"></mat-progress-bar>
</div>

<ng-template #containerSubmenu>
  <ng-content select="[subMenu]"></ng-content>
</ng-template>

<ng-template #containerActions>
  <ng-content select="[actions]"></ng-content>
</ng-template>
